module.exports = __webpack_public_path__ + "static/media/BarberShop.69b29210.jpg";